/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostProjectAutomatedRolloutConfigPathParams = NonNullable<
  operations['postProjectAutomatedRolloutConfig']['parameters']['path']
>;

export type PostProjectAutomatedRolloutConfigRequestBody = OperationRequestBodyContent<
  operations['postProjectAutomatedRolloutConfig']
>;

export interface Input extends PostProjectAutomatedRolloutConfigPathParams {
  apiVersion?: string;
  body: PostProjectAutomatedRolloutConfigRequestBody;
}

export async function postProjectAutomatedRolloutConfig(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/automated-rollout-configs', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
